var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-card"},[_c('span',{staticClass:"count"},[_vm._v(_vm._s(_vm._f("formatBigNumber")(_vm.count)))]),_c('div',{staticClass:"label"},[_c('span',{staticClass:"label-text"},[_vm._v(_vm._s(_vm.label || _vm.$t(_vm.labelI18nKey)))]),(_vm.visibleArrow)?_c('i',{staticClass:"label-icon el-icon-arrow-right"}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }